import * as d3 from "d3";
import {responsivefy} from '../functions'

export default function (chart, divId, vizName,resData, filterParam) {
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    // axios.post(url, filterParam).then(res => {
        let data = filterParam

        var svg = d3.select(divId).append("svg")
            .attr("width", chart.width)
            .attr("height", chart.height)
            .call(responsivefy)

        var g = svg.append("g")
            .attr("transform", "translate(" + (chart.width / 2 + 40) + "," + (chart.height / 2 + 90) + ")");

        var stratify = d3.stratify()
            .id(function (d) {
                return d.dim1_name
            })
            .parentId(function (d) {
                return d.dim1_name.substring(0, d.dim1_name.lastIndexOf('.'))
            })

        var tree = d3.tree()
            .size([360, 500])
            .separation(function (a, b) {
                return (a.parent == b.parent ? 1 : 0.5) / a.depth;
            });

        var root = tree(stratify(data));

        var link = g.selectAll(".link")
            .data(root.descendants().slice(1))
            .enter().append("path")
            .attr("class", "link")
            .attr("d", function (d) {
                return "M" + project(d.x, d.y)
                    + "C" + project(d.x, (d.y + d.parent.y) / 2)
                    + " " + project(d.parent.x, (d.y + d.parent.y) / 2)
                    + " " + project(d.parent.x, d.parent.y);
            })
            .style("fill", "none")
            .style("stroke", "#555")
            .style("stroke-opacity", "0.2")
            .style("stroke-width", "1.5px");

        console.warn(link)
        var node = g.selectAll(".node")
            .data(root.descendants())
            .enter().append("g")
            .attr("class", function (d) {
                return "node" + (d.children ? " node--internal" : " node--leaf");
            })
            .attr("transform", function (d) {
                return "translate(" + project(d.x, d.y) + ")";
            });

        node.append("circle").attr("r", 2.5);

        node.append("text")
            .attr("dy", ".31em")
            .attr("x", function (d) {
                return d.x < 180 === !d.children ? 6 : -6;
            })
            .style("text-anchor", function (d) {
                return d.x < 180 === !d.children ? "start" : "end";
            })
            .attr("transform", function (d) {
                return "rotate(" + (d.x < 180 ? d.x - 90 : d.x + 90) + ")";
            })
            .text(function (d) {
                return d.data.dim1_name.substring(d.data.dim1_name.lastIndexOf(".") + 1);
            });
    // });

    function project(x, y) {
        var angle = (x - 90) / 180 * Math.PI, radius = y;
        return [radius * Math.cos(angle), radius * Math.sin(angle)];
    }
}
